import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor(private translate: TranslateService) {}

  async setInitialAppLanguage(): Promise<void> {
    this.translate.setDefaultLang('en');
    const appLanguages = ['fr', 'en'];

    const language = navigator.language.split('-')[0];

    if (appLanguages.includes(language)) {
      try {
        await this.translate.use(language).toPromise();
      } catch (error) {
        console.error('Error when setting the App language');
      }
    } else {
      this.translate.use(this.translate.defaultLang);
    }
  }

  getLanguage(): string {
    return this.translate.currentLang;
  }
}
